import { Box, Typography } from '@mui/material'
import { styled, withStyles } from '@mui/styles'

export const PopupPosition = styled(Box)(({ offset = { x: 0, y: 0 } }) => {
  return ({
    position: 'relative',
    transform: `translate(${offset.x}px, ${offset.y}px)`,
    zIndex: 1
  })
})

export const InfoPopupContainer = styled(Box)(() => {
  return ({
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
  })
})

export const InfoPopupContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingTop: 12,
  paddingRight: 16,
  paddingBottom: 10,
  paddingLeft: 16,
  gap: theme.spacing(0.5),
  backgroundColor: theme.palette.common.white,
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px',
  opacity: 1
}))

export const InfoPopupStatus = styled(Box)(({ theme, sitecolor }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  color: theme.palette.common.white,
  backgroundColor: sitecolor || theme.palette.grey[100],
  borderBottomLeftRadius: '16px',
  borderBottomRightRadius: '16px',
  opacity: 1
}))

export const LoadingPopup = styled(Box)(({ theme, sitecolor }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  color: theme.palette.common.white,
  backgroundColor: sitecolor || theme.palette.grey[100],
  borderRadius: '16px',
  opacity: 1
}))

export const PopupTitle = withStyles(() => ({
  root: {
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.333,
    whiteSpace: 'nowrap'
  }
}))(Typography)

export const PopupLabel = withStyles(() => ({
  root: {
    fontWeight: 400,
    fontSize: 11,
    lineHeight: 1,
    whiteSpace: 'nowrap'
  }
}))(Typography)

export const PopupStatusLabel = withStyles(() => ({
  root: {
    fontWeight: 500,
    fontSize: 12,
    lineHeight: 1.333,
    whiteSpace: 'nowrap'
  }
}))(Typography)

export const PopupContainer = styled(Box)({
  boxSizing: 'border-box',
  padding: '8px 10px',
  width: 'max-content',
  maxWidth: 260,
  backgroundColor: 'white',
  borderRadius: '16px',
  display: 'flex',
  alignItems: 'flex-start',
  overflow: 'hidden'
})

export const ParentHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  position: 'relative'
})

export const ParentIcon = styled(Box)(({ isRack }) => ({
  width: 22,
  height: 22,
  borderRadius: '6px',
  ...(isRack && {
    backgroundColor: '#a99683',
    border: '2px solid #292929',
  }),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  zIndex: 2
}))

export const ParentLabel = styled(Typography)({
  fontSize: 12,
  fontWeight: 500,
  color: '#464646',
  maxWidth: 210,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
})

export const VerticalLine = styled(Box)(({ height, left, top }) => ({
  position: 'absolute',
  left,
  top,
  width: 0,
  height,
  borderLeft: '1.5px solid #CCCCCC',
  zIndex: 1
}))

export const TreeContainer = styled(Box)({
  marginLeft: 0,
  marginTop: -4
})

export const ChildContainer = styled(Box)(({ height }) => ({
  display: 'flex',
  alignItems: 'center',
  minHeight: height,
  position: 'relative'
}))

export const HorizontalBranch = styled(Box)(({ width, left, top }) => ({
  position: 'absolute',
  left,
  top,
  width,
  height: 0,
  borderTop: '1.5px solid #CCCCCC',
  transform: 'translateY(-50%)'
}))

export const CurvedBranch = styled(Box)(({ width, left }) => ({
  position: 'absolute',
  left,
  top: 0,
  width,
  height: '16px',
  borderLeft: '1.5px solid #CCCCCC',
  borderBottom: '1.5px solid #CCCCCC',
  borderBottomLeftRadius: '8px'
}))

export const ChildContent = styled(Box)(({ marginLeft }) => ({
  marginLeft,
  display: 'flex',
  alignItems: 'center',
  maxWidth: 224
}))

export const ChildLabel = styled(Typography)({
  fontSize: 12,
  fontWeight: 400,
  color: '#464646',
  marginLeft: 8,
  maxWidth: 196,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
})
